export const SUBTITLE_ELIGIBILITY = 'Eligibility';
export const REQUIRES_ELIGIBLE_EMAIL_FOR_GYM =
  'Gym access requires FCM-eligible email';
export const USES_FITNESS_CENTER_FOR_ELIGIBILITY =
  'Provides app access to anyone with active gym membership';
export const USES_ELIGIBILITY_SERVICE_TYPE =
  'Gym members need a special MBO package to get app access';

export const SUBTITLE_OPT_IN_FEATURES = 'Opt-In Features';
export const USES_PERSONAL_TRAINING = 'Virtual Personal Training';
export const USES_HIGH_PERFORMANCE_COACHING = 'High-Performance Coaching';
export const USES_MBO_REGISTRATION_FLOW = 'In-App MBO Registration';
export const USES_MBO_SSO = 'MBO SSO';
export const USES_CUSTOM_CHALLENGES = 'Custom Challenges';

export const SUBTITLE_CLIENT_OFFERINGS = 'Client Offerings';
export const COLLECTS_MEMBER_DATA = 'Employer Incentives';
export const COLLECTS_MEMBER_DATA_FOR_EEP = 'Employer Engagement Program';
export const MAX_FAMILY_MEMBERS = 'Family Sharing (number of invitations)';

export const SUBTITLE_OTHER_CONFIGS = 'Other Configs';
export const INACTIVITY_DURATION =
  'Require app users to log in again after N minutes of inactivity';
export const ALLOWS_COACHES_TO_CREATE_MEMBERS =
  'Allow coaches to create new members via Coach Hub';
export const ALLOWS_IN_APP_TRANSACTIONS = 'Allow in-app transactions';
export const STRICT_APP_CHECK =
  'Block authentication requests from outside the app (detect jailbreaks)';
export const NEEDS_US_TO_FIX_THEIR_USERNAMES = `Force capitalization of people's names (used if client IdP sends BRAD not Brad)`;

export const SUBTITLE_INTEGRATIONS = 'Integrations';

export const SUBTITLE_OPERATIONS = 'Operations';
export const IS_ARCHIVED = 'Is Archived';
export const IS_ARCHIVED_HELPER_TEXT = false;
export const USES_SSO = 'Is using SSO';
export const USES_SSO_HELPER_TEXT =
  'Cannot be configured from admin. Contact engineering.';
export const IS_FCM_ONLY = 'Is FCM Only';
export const IS_FCM_ONLY_HELPER_TEXT =
  'Leave OFF unless explicitly requested by the client. At FCM-Only clients, members are barred from using the Exos app.';
